import { show } from "@intercom/messenger-js-sdk";
import { Box, Button, Divider, Sheet, Typography } from "@mui/joy";
import { useSignOutMutation } from "@nerdjs/account-kit";
import { useLocalStorage } from "@uidotdev/usehooks";
import moment from "moment";
import { useDispatch } from "react-redux";
import { setFormOpen } from "../reducers/rhapsody";
import { useMyMember } from "../redux/member/memberHooks";
import { AppConfig } from "../environement";

/**
 *
 * @returns {ReactElement} Settings page
 */
export function Settings() {
  const dispatch = useDispatch();
  const [signout] = useSignOutMutation();
  const { member } = useMyMember();
  const [week, setWeek] = useLocalStorage("WeeksStartOn", "0");

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flex: 1,
        p: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: 600,
          width: "100%",
          flexDirection: "column",
          gap: 1,
          display: "flex",
          alignItems: "stretch",
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <img
            src={"https://storage.googleapis.com/rhapsody/logos/logo_main.png"}
            height={50}
          />
        </Box>
        <Box />
        <Box>
          <Typography level="body3">MY ACCOUNT</Typography>
          <Sheet variant="soft" sx={{ borderRadius: 8 }}>
            <Button
              size="lg"
              fullWidth
              sx={{ justifyContent: "space-between" }}
              variant="plain"
              // endDecorator={"Hello"}
              onClick={() =>
                dispatch(
                  setFormOpen({ isOpen: true, formID: "accountCredentials" })
                )
              }
              color="neutral"
            >
              <Typography
                level="body2"
                sx={{ fontWeight: 600, color: "#424242" }}
                startDecorator={
                  <i
                    style={{ color: "#2196f3" }}
                    className="fa-solid fa-shield"
                  ></i>
                }
              >
                Email login & phone
              </Typography>
            </Button>
            <Divider />
            <Button
              size="lg"
              fullWidth
              sx={{ justifyContent: "space-between" }}
              variant="plain"
              onClick={() =>
                dispatch(
                  setFormOpen({ isOpen: true, formID: "changePassword" })
                )
              }
              // endDecorator={"Hello"}
              color="neutral"
            >
              <Typography
                level="body2"
                sx={{ fontWeight: 600, color: "#424242" }}
                startDecorator={
                  <i
                    style={{ color: "#2196f3" }}
                    className="fa-solid fa-lock"
                  ></i>
                }
              >
                Change Password
              </Typography>
            </Button>
            <Divider />
            <Button
              size="lg"
              fullWidth
              sx={{ justifyContent: "space-between" }}
              variant="plain"
              onClick={() =>
                dispatch(setFormOpen({ isOpen: true, formID: "passkeys" }))
              }
              color="neutral"
            >
              <Typography
                level="body2"
                sx={{ fontWeight: 600, color: "#424242" }}
                startDecorator={
                  <i
                    style={{ color: "#2196f3" }}
                    className="fa-solid fa-fingerprint"
                  ></i>
                }
              >
                Passkeys
              </Typography>
            </Button>
          </Sheet>
        </Box>
        <Box>
          <Typography level="body3">PREFERENCES</Typography>
          <Sheet variant="soft" sx={{ borderRadius: 8 }}>
            <Button
              size="lg"
              fullWidth
              onClick={() =>
                dispatch(
                  setFormOpen({ isOpen: true, formID: "smsNotifications" })
                )
              }
              sx={{ justifyContent: "space-between" }}
              variant="plain"
              endDecorator={
                <Typography level="body3">
                  {member?.contactBySMS ? "Active" : "Off"}
                </Typography>
              }
              color="neutral"
            >
              <Typography
                level="body2"
                sx={{ fontWeight: 600, color: "#424242" }}
                startDecorator={
                  <i
                    style={{ color: "#2196f3" }}
                    className="fa-solid fa-comment-sms"
                  ></i>
                }
              >
                SMS Notifications
              </Typography>
            </Button>
            <Divider />
            <Button
              size="lg"
              fullWidth
              sx={{ justifyContent: "space-between" }}
              variant="plain"
              endDecorator={
                <Typography level="body3">
                  {week === "0" ? "Sunday" : ""}
                  {week === "1" ? "Monday" : ""}
                </Typography>
              }
              color="neutral"
              onClick={() =>
                dispatch(setFormOpen({ isOpen: true, formID: "weeksStartOn" }))
              }
            >
              <Typography
                level="body2"
                sx={{ fontWeight: 600, color: "#424242" }}
                startDecorator={
                  <i
                    style={{ color: "#2196f3" }}
                    className="fa-solid fa-calendar"
                  ></i>
                }
              >
                Weeks start on
              </Typography>
            </Button>
          </Sheet>
        </Box>
        <Box>
          <Typography level="body3">HELP</Typography>
          <Sheet variant="soft" sx={{ borderRadius: 8 }}>
            <Button
              size="lg"
              fullWidth
              sx={{ justifyContent: "space-between" }}
              variant="plain"
              // endDecorator={"Sunday"}
              onClick={() => show()}
              color="neutral"
            >
              <Typography
                level="body2"
                sx={{ fontWeight: 600, color: "#424242" }}
                startDecorator={
                  <i
                    style={{ color: "#2196f3" }}
                    className="fa-solid fa-comments"
                  ></i>
                }
              >
                Chat with Support
              </Typography>
            </Button>

            <Divider />
            <Button
              size="lg"
              fullWidth
              sx={{ justifyContent: "space-between" }}
              variant="plain"
              // endDecorator={"Sunday"}
              onClick={() =>
                window.open(
                  "mailto:support@rhapsody.la?subject=Hello Team&body=Hello Team!",
                  "_blank"
                )
              }
              color="neutral"
            >
              <Typography
                level="body2"
                sx={{ fontWeight: 600, color: "#424242" }}
                startDecorator={
                  <i
                    style={{ color: "#2196f3" }}
                    className="fa-solid fa-paper-plane"
                  ></i>
                }
              >
                Email the Team
              </Typography>
            </Button>
            <Divider />
            <Button
              size="lg"
              fullWidth
              sx={{ justifyContent: "space-between" }}
              variant="plain"
              // endDecorator={"Sunday"}
              onClick={() =>
                dispatch(
                  setFormOpen({ isOpen: true, formID: "deleteMyAccount" })
                )
              }
              color="neutral"
            >
              <Typography
                level="body2"
                sx={{ fontWeight: 600, color: "#424242" }}
                startDecorator={
                  <i
                    style={{ color: "#2196f3" }}
                    className="fa-solid fa-trash"
                  ></i>
                }
              >
                Delete my Account
              </Typography>
            </Button>
            <Divider />
            <Button
              size="lg"
              fullWidth
              sx={{ justifyContent: "space-between" }}
              variant="plain"
              // endDecorator={"Sunday"}
              onClick={() => window.open("https://rhapsody.la/", "_blank")}
              color="neutral"
            >
              <Typography
                level="body2"
                sx={{ fontWeight: 600, color: "#424242" }}
                startDecorator={
                  <i
                    style={{ color: "#2196f3" }}
                    className="fa-solid fa-circle-info"
                  ></i>
                }
              >
                About Rhapsody
              </Typography>
            </Button>
          </Sheet>
        </Box>
        <Box>
          <Typography level="body3">LEGAL</Typography>
          <Sheet variant="soft" sx={{ borderRadius: 8 }}>
            <Button
              size="lg"
              fullWidth
              sx={{ justifyContent: "space-between" }}
              variant="plain"
              endDecorator={<i className="fa-regular fa-arrow-up-right"></i>}
              color="neutral"
              onClick={() =>
                window.open("https://legal.rhapsody.la/privacy-policy")
              }
            >
              <Typography
                level="body2"
                sx={{ fontWeight: 600, color: "#424242" }}
                startDecorator={
                  <i
                    style={{ color: "#2196f3" }}
                    className="fa-solid fa-shield-halved"
                  ></i>
                }
              >
                Privacy Policy
              </Typography>
            </Button>
            <Divider />
            <Button
              size="lg"
              fullWidth
              sx={{ justifyContent: "space-between" }}
              variant="plain"
              endDecorator={<i className="fa-regular fa-arrow-up-right"></i>}
              color="neutral"
              onClick={() =>
                window.open("https://legal.rhapsody.la/terms-and-conditions")
              }
            >
              <Typography
                level="body2"
                sx={{ fontWeight: 600, color: "#424242" }}
                startDecorator={
                  <i
                    style={{ color: "#2196f3" }}
                    className="fa-solid fa-file"
                  ></i>
                }
              >
                Terms and Conditions
              </Typography>
            </Button>
          </Sheet>
        </Box>
        <Box />
        <Box />
        <Box>
          <Sheet variant="soft" sx={{ borderRadius: 8 }}>
            <Button
              size="lg"
              fullWidth
              sx={{ justifyContent: "space-between" }}
              variant="plain"
              // endDecorator={"Sunday"}
              onClick={() => {
                signout()
                  .unwrap()
                  .then(() => {
                    window.location.replace(AppConfig.front["401Redirect"]);
                  });
              }}
              color="neutral"
            >
              <Typography
                level="body2"
                sx={{ fontWeight: 600, color: "#424242" }}
                startDecorator={
                  <i
                    style={{ color: "#2196f3" }}
                    className="fa-solid fa-power-off"
                  ></i>
                }
              >
                Sign out
              </Typography>
            </Button>
          </Sheet>
        </Box>
        <Box />
        <Box />
        <Typography level="body3" sx={{ textAlign: "center" }}>
          v{window.app_info?.tag}
          <br />
          ©️ {moment().format("YYYY")} WID LLC. All Right Reserved.
        </Typography>
        <Typography level="body4" sx={{ textAlign: "center" }}>
          Rhapsody, Orchestra Management System
          <br />
          Developed in the USA
          <br />
          www.rhapsody.la
        </Typography>
      </Box>
    </Box>
  );
}
